// extracted by mini-css-extract-plugin
export default {"disabledMobileRecorder":"MobileRecorderEntry_disabledMobileRecorder__j4f-w","warning":"MobileRecorderEntry_warning__2M+0I"};